import {
    GET_FEATURED_ASSESSMENTS_REQUEST,
    GET_FEATURED_ASSESSMENTS_SUCCESS,
    GET_FEATURED_ASSESSMENTS_FAILURE
} from '../actions';


const initialState = {};

const FeaturedAssessmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_FEATURED_ASSESSMENTS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_FEATURED_ASSESSMENTS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: {...state.data, [action.request]: action.payload}});
        case GET_FEATURED_ASSESSMENTS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default FeaturedAssessmentsReducer;